module.exports = __webpack_public_path__ + "img/WazeIcon.9747fa28.png";